type AnyTelegramWebApp = {
  ready: () => void;
  expand: () => void;
  close?: () => void;
  openInvoice?: (url: string, callback?: (status: 'paid' | 'cancelled' | 'failed' | 'pending') => void) => void;
  showAlert?: (message: string, callback?: () => void) => void;
  colorScheme?: 'light' | 'dark';
  themeParams?: Record<string, string>;
  initData?: string;
  initDataUnsafe?: any;
};

export function getTelegramWebApp(): AnyTelegramWebApp | null {
  const w = window as any;
  return w?.Telegram?.WebApp ?? null;
}

export function getTelegramInitData(): string {
  const tg = getTelegramWebApp();
  return String(tg?.initData || '');
}

export function applyTelegramThemeCssVars(tg: AnyTelegramWebApp) {
  const p = tg?.themeParams || {};

  const isDark = tg?.colorScheme === 'dark';
  document.documentElement.style.setProperty('--bg', p.bg_color || (isDark ? '#0b1220' : '#f9fafb'));
  document.documentElement.style.setProperty('--text', p.text_color || (isDark ? 'rgba(255,255,255,0.92)' : '#101828'));
  document.documentElement.style.setProperty('--muted', isDark ? 'rgba(255,255,255,0.62)' : '#6a7282');
  document.documentElement.style.setProperty('--card', p.secondary_bg_color || (isDark ? 'rgba(255,255,255,0.06)' : '#ffffff'));
  document.documentElement.style.setProperty('--border', isDark ? 'rgba(255,255,255,0.12)' : '#e5e7eb');
  document.documentElement.style.setProperty('--accent', p.button_color || '#2aabee');
}
